import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { delivery } from './delivery/config';
import { pickUp } from './pickup/config';

export const cementBulk = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: delivery,
  [SHIPPING_CONDITION_CODE.PICK_UP]: pickUp,
};
